import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar } from '@ionic/react';
import ExploreContainer from '../components/ExploreContainer';
import './Tab1.css';
import Notification from '../components/Notification';

const Tab1: React.FC = () => {
  return (
    <IonPage>
      <Notification />
      <IonHeader>
        <IonToolbar>
          <IonTitle>CyM Internet</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle size="large">CyM Internet</IonTitle>
          </IonToolbar>
        </IonHeader>
        <ExploreContainer name="Bla bla bla" />
      </IonContent>
    </IonPage>
  );
};

export default Tab1;
